import { render } from "./ProblemLayout.vue?vue&type=template&id=60a544e8&scoped=true"
import script from "./ProblemLayout.vue?vue&type=script&lang=js"
export * from "./ProblemLayout.vue?vue&type=script&lang=js"

import "./ProblemLayout.vue?vue&type=style&index=0&id=60a544e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a544e8"]])

export default __exports__